import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
var DropDownMenu = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, children = _a.children, size = _a.size, _c = _a.caret, caret = _c === void 0 ? false : _c, _d = _a.addShowClass, addShowClass = _d === void 0 ? false : _d;
    var _e = useState(false), dropdownOpen = _e[0], setDropdownOpen = _e[1];
    var toggle = function () { return setDropdownOpen(function (prevState) { return !prevState; }); };
    var dropdownClass = ['drop-down-menu', addShowClass ? 'show' : '']
        .filter(Boolean)
        .join(' ');
    return (React.createElement(Dropdown, { className: dropdownClass, isOpen: dropdownOpen, toggle: toggle, size: size },
        React.createElement(DropdownToggle, { className: "toggle", caret: caret }, children),
        React.createElement(DropdownMenu, { className: "menu" }, items.map(function (_a) {
            var id = _a.id, isDivider = _a.isDivider, isHeader = _a.isHeader, isText = _a.isText, content = _a.content, onClick = _a.onClick, toggle = _a.toggle;
            if (isDivider) {
                return React.createElement(DropdownItem, { key: id, id: id, divider: true });
            }
            else {
                return (React.createElement(DropdownItem, { key: id, id: id, className: "item", header: isHeader, text: isText, onClick: onClick, toggle: toggle }, content));
            }
        }))));
};
export default DropDownMenu;
